// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .tenant-admin-dashboard-state-header{
        padding: 10px 15px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-admin-dashboard-state-header p{
        margin: 0px;
        font-size: 14px;
    }
    .tenant-admin-dashboard-state-header h1{
        margin: 0px;
        font-size: 26px;
        font-weight: 600;
    }
    .tenant-admin-dashboard-body{
        width: 100%;
        height: 500vh;
        margin: 25px 0px;
        position: relative;
    }
}
@media screen and (max-width:949px){
    .tenant-admin-dashboard-state-header{
        padding: 10px 15px;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .tenant-admin-dashboard-state-header p{
        margin: 0px;
        font-size: 14px;
    }
    .tenant-admin-dashboard-state-header h1{
        margin: 0px;
        font-size: 26px;
        font-weight: 600;
    }
    .tenant-admin-dashboard-body{
        width: 100%;
        height: 500vh;
        margin: 25px 0px;
        position: relative;
        overflow: auto;
        padding-bottom: 10vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Dashboards/DashboardState.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,4DAA4D;IAChE;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,4DAA4D;IAChE;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,aAAa;QACb,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,oBAAoB;IACxB;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .tenant-admin-dashboard-state-header{\r\n        padding: 10px 15px;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .tenant-admin-dashboard-state-header p{\r\n        margin: 0px;\r\n        font-size: 14px;\r\n    }\r\n    .tenant-admin-dashboard-state-header h1{\r\n        margin: 0px;\r\n        font-size: 26px;\r\n        font-weight: 600;\r\n    }\r\n    .tenant-admin-dashboard-body{\r\n        width: 100%;\r\n        height: 500vh;\r\n        margin: 25px 0px;\r\n        position: relative;\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .tenant-admin-dashboard-state-header{\r\n        padding: 10px 15px;\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .tenant-admin-dashboard-state-header p{\r\n        margin: 0px;\r\n        font-size: 14px;\r\n    }\r\n    .tenant-admin-dashboard-state-header h1{\r\n        margin: 0px;\r\n        font-size: 26px;\r\n        font-weight: 600;\r\n    }\r\n    .tenant-admin-dashboard-body{\r\n        width: 100%;\r\n        height: 500vh;\r\n        margin: 25px 0px;\r\n        position: relative;\r\n        overflow: auto;\r\n        padding-bottom: 10vh;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
